export default "__VITE_ASSET__CqISiKyw__"